import { makeEditorModal } from '../Modal';
import { Editor } from 'tinymce';
import { decodeMML, getData, insertToEditor, setWindowNode, toJsonHtml } from '../core/Utils';
import { FeatureClass } from '../core/FeatureClass';



export function addPexamath(editor:Editor){
    const config = {
        featureName: "pexamath",
        editor: editor,
        id: "pexamath",
        icon: "superscript",
        tooltip: 'Formel erstellen',
        menuItems: [{
            name: 'edit-pexamath',
            icon: 'edit-block',
            text: 'Bearbeiten',
            action: (editor:Editor, command:string) => {
                const node = setWindowNode(editor);
                const data = node.getAttribute('data-mathml')
                const mml = decodeMML(data)
                pexamath.load(mml)
                // createPopupModal(editor, command, data);
            }
        }],
        buttonAction: (command:string) => {
            pexamath.load()
            pexamath.afterExport = (mathml:string) => {
                editor.execCommand(command, mathml)
                // insertToEditor(mathml, editor)
            }
            // '<math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mn>2</mn><mn>1</mn></mfrac><mo>+</mo><msup><mi>x</mi><mn>2</mn></msup><mo>+</mo><msub><mi>a</mi><mn>2</mn></msub><mo>+</mo><msqrt><mn>2</mn></msqrt><mo>+</mo><mroot><mn>2</mn><mn>2</mn></mroot><mo>+</mo><mfenced><mtable><mtr><mtd><mn>1</mn></mtd></mtr><mtr><mtd><mn>2</mn></mtd></mtr><mtr><mtd><mn>3</mn></mtd></mtr></mtable></mfenced><mo>+</mo><mover><mn>2</mn><mo>&#8640;</mo></mover></math>'
        },
        commandAction: (mathml:string) => {
            insertToEditor(mathml, editor)
        }    
    }
    const feature = new FeatureClass(config);
    feature.addToEditor(editor);
}



